
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TransactionCtlService } from '../api/services';
import { ExcelService } from '../common/excel.service';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-detaill-compense',
  imports: [ReactiveFormsModule, NgxPaginationModule],
  templateUrl: './detaill-compense.component.html',
  styleUrl: './detaill-compense.component.css'
})
export class DetaillCompenseComponent {

  pageConfig= {
    itemsPerPage: 20,
    currentPage: 0,
    totalItems: 0
   };

  transactions?:any;
  startDate='';
  endDate='';

  compenseForm:FormGroup;

  constructor(private formBuilder:FormBuilder,
    private trxService:TransactionCtlService,
     private excelService:ExcelService,
  ){
    this.compenseForm = this.formBuilder.group({
      startDate :['', [Validators.required]],
      endDate :['', [Validators.required]]
    });
  }


  getCompenseTransactions(start?:string,end?:string,pageSize:number=10,pageNumber:number=0,toExport:boolean=false){

    this.trxService.getDetailedCompense(
    
    pageSize, 
    pageNumber,
    start,
    end
     
    ).subscribe(
      {
        next:(resp)=>{
          if(toExport){
            let content =[["MONTANT","MONTANT + COMMISSIONS","COMMISSIONS","DATE","NOM ETABLISSEMENT",
           "MOYENS DE PAIEMENT","PART OPERATEURS","COMPENSE VERSUS & FIL ROUGE","PART VERSUS & FIL ROUGE",
           "PART PARENT D'ELEVES","RESTE COMMISSIONS","PART FIL ROUGE","PART VERSUS"]];
            
            resp?.content?.forEach(el => {
              var line:any[] =[el.requestAmount,el.paidAmount,el.commission,el.paymentDate,el.merchant?.name,
                el.bank?.name,el.partPaymentMeans,el.amountBusinessDeveloper,el.sharedCommission,el.partStudentParent,
              el.partGlobalVersus,el.partBusinessDeveloper,el.partVersus];
              content.push(line);
            });
            this.excelService.exportAsExcelFile(content,'details-compense','details-compense');

          }else {
           this.transactions =resp;
           this.pageConfig.currentPage= resp.page?.number!!+1;
           this.pageConfig.itemsPerPage= resp.page?.size!!;
           this.pageConfig.totalItems =  resp.page?.totalElements!!;
          }
        }
      }
    )

  }
  onGetCompenseTrx(){

    let form = this.compenseForm.value;
    let startDate=form.startDate;
    let endDate =form.endDate;
    if(form.startDate.length>0){
       let start = startDate.substring(8,10)+'/'+startDate.substring(5,7)+'/'+startDate.substring(0,4);
       this.startDate = start;
    }
    if(form.endDate.length>0){
      let end = endDate.substring(8,10)+'/'+endDate.substring(5,7)+'/'+endDate.substring(0,4);
      this.endDate = end;
   }
    console.log(form);
    console.log(endDate);
    this.getCompenseTransactions(this.startDate,this.endDate);

  }
  onNextPage(event:number){
    console.log("page"+event);
    this.getCompenseTransactions(this.startDate,this.endDate, this.pageConfig.itemsPerPage,event-1);
  }
  exportToExcel(){
    this.getCompenseTransactions(this.startDate,this.endDate, -1,0,true);
  }

}
